module.exports = __webpack_public_path__ + "6d27b25fd09e91605f7da53d2945cad5.fbx";